import moment from 'moment';
import accounting from 'accounting';

export function phone(str) {
    if(!str) {
        return '';
    }
    return `( ${str.substring(0, 3)} ) ${str.substring(3, 6)} - ${str.substring(6)}`;
}

export function date(dateStr, format = 'LL') {
    return moment.utc(dateStr)
        .utcOffset(-((new Date()).getTimezoneOffset()))
        .format(format);
}

export function truncate(str, limit = 50) {
    if(!str || str.length <= limit) {
        return str;
    }
    return str.substring(0, limit - 3) + '...';
}

export function upperFirstThenLower(str) {
    if(!str) {
        return '';
    }
    let words = str.split(' ').map(word => {
        if(word.length === 1) {
            return word.toUpperCase();
        }
        return word[0].toUpperCase() + word.substring(1).toLowerCase();
    });
    return words.join(' ');
}

export function currency(amount, precision = 2) {
    if(typeof amount !== 'number') {
        return '';
    }
    return accounting.formatMoney(amount / 100, '$', precision);
}

